import styled from 'styled-components';
import Assignments from './Assignments';
import { colorSchema } from 'utils/style';

export default styled(Assignments)`
  .assignments {
    border-bottom: ${props =>
      props.showAtSide
        ? `1px solid ${props.theme.base.colorSchema.grey200}`
        : '0'};
    display: flex;
    flex-direction: column;
    justify-content: ${props => (props.showAtSide ? 'flex-start' : 'flex-end')};
    padding: ${props => (props.showAtSide ? '1.6rem 0' : '0')};

    &__driver {
      font-weight: bold;
      margin-bottom: 0.5rem;
      text-align: ${props => (props.showAtSide ? 'left' : 'right')};
    }

    &__driver-tag {
      margin-bottom: 0.5rem;
    }

    &__vehicles {
      display: flex;
      justify-content: ${props =>
        props.showAtSide ? 'flex-start' : 'flex-end'};
    }

    &__plate {
      margin: ${props => (props.showAtSide ? '0' : '0 0.5rem')};

      &:last-of-type {
        margin-right: 0;
      }
    }

    &__pending-text {
      color: ${colorSchema('grey700')};
      font-size: 1.6rem;
    }
  }
`;
